import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export function getRestaurants() {
    return axiosInstance.get(`user/restaurants`);
}


export function createRestaurant(restaurant) {
    console.log(restaurant);
    const state = store.getState();
    restaurant.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", restaurant.name);
    // formData.append("image", restaurant.image);
    // formData.append("status", restaurant.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...restaurant
    };
    return axiosInstance.post("user/register-restaurant", postData,);
}
export function updateRestaurant(restaurant,id) {
    console.log(restaurant);
    const state = store.getState();
    restaurant.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", restaurant.name);
    // formData.append("image", restaurant.image);
    // formData.append("status", restaurant.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...restaurant
    };
    return axiosInstance.put("user/restaurants?id="+id, postData,);
}
export function changeStatusRestaurant(restaurant,id) {
    console.log(restaurant);
    const state = store.getState();
    restaurant.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", restaurant.name);
    // formData.append("image", restaurant.image);
    // formData.append("status", restaurant.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...restaurant
    };
    return axiosInstance.put("user/restaurants/status?id="+id, postData,);
}

export function getSelectedRestaurant(id) {
    return axiosInstance.get(`user/restaurants/show?id=`+id);
}
export function deleteRestaurant(id) {
    return axiosInstance.delete(`user/restaurants?id=`+id);
}